import ActionButton from "../../../common/ActionButton";
import React, {useState} from "react";
import {removeUserAsync, selectAccount} from "../../../../app/store/reducers/auth/authReducer";
import {toast} from "react-toastify";
import {Button, Modal} from "react-bootstrap";
import FalconCloseButton from "../../../common/FalconCloseButton";
import {useSelector} from "react-redux";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import EventBus from "../../../../app/eventbus/EventBus";
import {ACCOUNT_REMOVE_FROM_ORGANIZATION_SUCCEED} from "../../../../app/eventbus/authEvents";


const DeleteUser = ({username}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const account = useSelector(selectAccount)
    const [isShow, setIsShow] = useState(false)

    const onDeleteUser = async () => {
        try {
            await removeUserAsync({username})
            toast.success(t(lang, "edi.common.user_organization_delete"));
            EventBus.dispatch(ACCOUNT_REMOVE_FROM_ORGANIZATION_SUCCEED);
            setIsShow(false)
        } catch (error) {
            console.log(error);
        }
    }


    const handlerClose = () => {
        setIsShow(false)
    }

    const handlerOpen = () => {
        setIsShow(true)
    }


    return (
        <>
            <ActionButton
                icon="trash-alt"
                title="Удалить"
                variant="action"
                className={username !== account.username ? "p-0 text-danger d-inline" : "p-0 text-danger d-none"}
                onClick={handlerOpen}
            />


            <Modal show={isShow}>
                <Modal.Header>
                    <Modal.Title>{t(lang, "edi.common.user_organization_delete_title")}</Modal.Title>
                    <FalconCloseButton onClick={handlerClose}/>
                </Modal.Header>
                <Modal.Body>
                    <p>{t(lang, "edi.common.user_organization_delete_ask")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary"
                            onClick={handlerClose}>{t(lang, "edi.common.select_yes_or_no.option.no")}</Button>
                    <Button variant="danger"
                            onClick={onDeleteUser}>{t(lang, "edi.common.select_yes_or_no.option.yes")}</Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default DeleteUser;